<template>
  <div>
    <el-form ref="form"
             :model="form"
             label-width="120px"
             @submit.prevent.native="onSubmit">
      <el-row :gutter="30">
        <el-col :span="19">
          <div class="box">
            <div class="box__header">
              <span class="box__header--text">{{ getRouteName($route) }}</span>
            </div>
            <el-form-item label="Cena (zł)"
                          :error="errors.price">
              <el-input type="number" v-model="form.price"></el-input>
            </el-form-item>
            <el-form-item label="Ilość dostępnych leżaków"
                          :error="errors.quantity">
              <el-input type="number" v-model="form.quantity"></el-input>
            </el-form-item>
            <el-form-item label="Minimalna ilość przy rezerwacji"
                          :error="errors.min_to_book">
              <el-input type="number" v-model="form.min_to_book"></el-input>
            </el-form-item>
            <el-form-item label="Maksymalna ilość przy rezerwacji"
                          :error="errors.max_to_book">
              <el-input type="number" v-model="form.max_to_book"></el-input>
            </el-form-item>

            <el-form-item label="Typ leżaka" :error="errors.type">
              <el-select v-model="form.type" placeholder="Typ leżaka" clearable>
                <el-option v-for="loungerType in loungerTypes"
                           :key="loungerType.value"
                           :label="loungerType.label"
                           :value="loungerType.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Data"
                          :error="errors.date">
              <el-date-picker type="date"
                              format="yyyy/MM/dd"
                              value-format="yyyy-MM-dd"
                              placeholder="Data"
                              v-model="form.date"/>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="box">
            <div class="box__header">
              {{ $t('manage') }}
            </div>
            <el-form-item class="form__buttons" label-width="0">
              <el-button @click="onSubmit"
                         type="primary"
                         class="fluid form__button"
                         :loading="loading">
                {{ $t('submit') }}
              </el-button>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { Lounger } from '@/api/';

export default {
  data() {
    return {
      loungerTypes: [
        {
          "label": "Cabana (max 4 os.)",
          "value": "cabana"

        },
        {
          "label": "Opener Fan Cabana (max 4 os.)",
          "value": "opener fan cabana"

        },
        {
          "label": "Sunbed (minimum 2 w zestawie)",
          "value": "sunbed"

        },
        {
          "label": "Opener Fan Sunbed (minimum 2 w zestawie)",
          "value": "opener fan sunbed"

        }
      ],
      loading: false,
      form: {},
      errors: {},
      service: Lounger
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      if (this.$route.params.id) {
        this.service.get({id: this.$route.params.id}).then(response => {
          this.form = response.data
          this.form.price /= 100  // from gr to zł
        })
      }
    },
    onSubmit() {
      this.loading = true;
      const id = this.$route.params.id
      const payload = {...this.form}
      payload.price *= 100  // from zł to gr
      const service = id ? this.service.update({id: id}, payload) : this.service.save(payload)
      service
          .then(this.successHandler)
          .catch(this.errorHandler)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// LoungerForm.vue?2895ba7a